import React from 'react';
import { RemoveColumnPreset, SaveNewColumnPreset } from '~/components/SearchColumns';
import { RemovableOption, Select } from '~/components/Select';
import {
    ColumnPresetType,
    SearchContext,
    SearchContextType,
    ServicesContext,
    defaultColumnPresets,
} from '~/services';

interface SavedColumnPresetsProps {
    orderedColumns: string[];
    selectedPreset: string;
    setSelectedPreset: (preset: string) => void;
}
export function SavedColumnPresets({
    orderedColumns,
    selectedPreset,
    setSelectedPreset,
}: SavedColumnPresetsProps) {
    const context = React.useContext(ServicesContext);
    const { savedColumnPresets } = React.useContext(SearchContext) as SearchContextType;
    const [toRemove, setToRemove] = React.useState('');
    const [saveNew, setSaveNew] = React.useState(false);

    function remove(e: React.MouseEvent<HTMLButtonElement>, value: string) {
        e.stopPropagation();
        setToRemove(value);
    }

    const presetOptions = [
        ...defaultColumnPresets
            .filter(
                (preset) => !(context.user.hasFeatureToggle('hidden_foc') && preset.label === 'AW')
            )
            .map((x) => ({ value: x.label, label: x.label })),
        ...savedColumnPresets.map((x: ColumnPresetType) => ({
            value: x.label,
            label: x.label,
            remove,
        })),
    ];

    function handleSelectChange(x: SavedColumnPresetOptionType) {
        setSelectedPreset(x.value);
    }

    if (toRemove)
        return <RemoveColumnPreset colPreset={toRemove} onDismiss={() => setToRemove('')} />;

    if (saveNew)
        return (
            <SaveNewColumnPreset
                orderedColumns={orderedColumns}
                onDismiss={() => setSaveNew(false)}
                setSelectedPreset={setSelectedPreset}
            />
        );

    return (
        <div className="row">
            <div className="col col-md-5 offset-md-1">
                <Select
                    components={{ Option: RemovableOption }}
                    options={presetOptions}
                    value={{ value: selectedPreset, label: selectedPreset }}
                    placeholder="Column Presets"
                    label="Column Presets"
                    onChange={handleSelectChange}
                />
            </div>
            <div className="col col-md-5 text-end">
                <button
                    className="btn btn-primary"
                    type="button"
                    disabled={selectedPreset !== 'Custom'}
                    onClick={() => setSaveNew(true)}
                >
                    Save New Preset
                </button>
            </div>
        </div>
    );
}

export interface SavedColumnPresetOptionType {
    value: string;
    label: string;
    remove?: (e: React.MouseEvent<HTMLButtonElement>, label: string) => void;
}
